// src/components/SummaryCards.tsx
import { Card, Statistic } from "antd";
import { UserOutlined, AppstoreOutlined, DollarOutlined } from "@ant-design/icons";
import { Package } from "lucide-react";

interface SummaryCardsProps {
  totalClients: number;
  totalPackages: number;
  totalCubicVolume: string;
  totalMonthly: number;
}

export const SummaryCards: React.FC<SummaryCardsProps> = ({
  totalClients,
  totalPackages,
  totalCubicVolume,
  totalMonthly,
}) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: 16,
        marginBottom: 16,
      }}
    >
      <Card>
        <Statistic
          title="Total Clients"
          value={totalClients}
          prefix={<UserOutlined />}
        />
      </Card>
      <Card>
        <Statistic
          title="Total Packages"
          value={totalPackages}
          prefix={<Package />}
        />
      </Card>
      <Card>
        <Statistic
          title="Cubic Volume"
          value={totalCubicVolume}
          suffix="ft³"
          prefix={<AppstoreOutlined />}
        />
      </Card>
      <Card>
        <Statistic
          title="Est. Monthly Revenue"
          value={totalMonthly}
          precision={2}
          prefix={<DollarOutlined />}
        />
      </Card>
    </div>
  );
};
